define("shared/components/shared/post/secondary/activity/header", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--modalHeader cAP--modalHeader" data-test-id="post-activity-header">
    <h2 class="o--modalHeader__title u--m__b__xs qa--activity_modal_title">
      {{t "approval.secondary-modal.header.title"}}
    </h2>
    <p class="u--m__b__0 qa--activity_modal_description">
      {{t "approval.secondary-modal.header.subtitle"}}
    </p>
  </div>
  */
  {
    "id": "vd5iaQBE",
    "block": "[[[10,0],[14,0,\"o--modalHeader cAP--modalHeader\"],[14,\"data-test-id\",\"post-activity-header\"],[12],[1,\"\\n  \"],[10,\"h2\"],[14,0,\"o--modalHeader__title u--m__b__xs qa--activity_modal_title\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"approval.secondary-modal.header.title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--m__b__0 qa--activity_modal_description\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[\"approval.secondary-modal.header.subtitle\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/header.hbs",
    "isStrictMode": false
  });
  class HeaderComponent extends _component2.default {}
  _exports.default = HeaderComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, HeaderComponent);
});